import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import "./arrivals.css";

function Arrivals() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    axiosInstance
      .get("/posts/")
      .then((res) => {
        setPosts(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!posts.length) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === posts.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [posts]);
  if (loading) {
    return (
      <div className="slider-container">
        <div className="slider-card skeleton" style={{ height: "350px", width: "60%" }}>
          {/* This empty div with .skeleton class will show the pulsing effect */}
        </div>
      </div>
    );
  }

  if (!posts.length) return null;
  return (
    <div className="slider-container">
      <div className="slider-card">
        <img src={posts[currentIndex].image} alt="arrival" className="slider-image" />
        <div className="content-box">
          <p className="content-text">{posts[currentIndex].content}</p>
        </div>
      </div>
    </div>
  );
}

export default Arrivals;
